import(/* webpackMode: "eager" */ "/Users/yoko/renehuemer.com/website/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"700\"],\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/Users/yoko/renehuemer.com/website/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AnnouncementBanner"] */ "/Users/yoko/renehuemer.com/website/src/components/announcement-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/Users/yoko/renehuemer.com/website/src/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yoko/renehuemer.com/website/src/components/layout/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yoko/renehuemer.com/website/src/components/layout/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationProvider"] */ "/Users/yoko/renehuemer.com/website/src/components/navigation-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yoko/renehuemer.com/website/src/components/sections/cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SnipcartConsentWrapper"] */ "/Users/yoko/renehuemer.com/website/src/components/SnipcartConsentWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/Users/yoko/renehuemer.com/website/src/components/theme-provider.tsx");
